import React from 'react';
import { SectionStrategicPartnersProps } from './types/SectionStrategicPartners.types';
import SimpleGrid from '@legacy-vfuk/core-simple-grid';
import StrategicPartnerItem from '../../Elements/StrategicPartnerItem';
import {
  StrategicSectionWrapper,
  StrategicSectionHeader,
} from './styles/SectionStrategicPartners.styles';

const SectionStrategicPartners = ({
  section,
}: SectionStrategicPartnersProps) => {
  const { content, headerText } = section;

  return (
    <StrategicSectionWrapper>
      <div className="spring">
        <StrategicSectionHeader>{headerText}</StrategicSectionHeader>
        <div>
          <SimpleGrid
            layout={{
              sm: [4, 4, 4, 6, 6],
              md: [2],
            }}
            spacing={8}
            justify="center"
            verticalAlign="center"
          >
            {content?.map(partnerItem => {
              return (
                <StrategicPartnerItem
                  key={partnerItem.id}
                  partner={partnerItem}
                />
              );
            })}
          </SimpleGrid>
        </div>
      </div>
    </StrategicSectionWrapper>
  );
};

export default SectionStrategicPartners;
